import { data } from '../../svg/PlayCircle/data';
import { makeIcon } from '../makeIcon';

export const PlayCircle = makeIcon(data, 'play_circle', 'PlayCircle');

export default PlayCircle;
